import { clearStaleInsightSessionMarkers, consumeAuthPortalAccountVisit } from './authPortalAccountVisit';
import { isAuthPortalSessionAliveWithRecheck } from './authPortalSession';

/**
 * Extra AuthGuard check only after returning from OC /account.
 *
 * - No visit flag → 'ok' (cookie-only AuthGuard behavior; no auth/me probe).
 * - Visit flag + OC dead → clear stale Insight cookies and require MUI login.
 * - Visit flag + OC alive → 'ok' (user cancelled / returned still logged in).
 *
 * @returns {'ok' | 'login'}
 */
export async function verifyAuthGuardSession({
  consumeVisit = consumeAuthPortalAccountVisit,
  clearStaleMarkers = clearStaleInsightSessionMarkers,
  probeOcSession = isAuthPortalSessionAliveWithRecheck,
} = {}) {
  if (!consumeVisit()) {
    return 'ok';
  }

  const ocAlive = await probeOcSession();
  if (!ocAlive) {
    clearStaleMarkers();
    return 'login';
  }

  return 'ok';
}
